import styled from 'styled-components';

export const mainTurboColor = '#ca1016';
export const defaultBorder = '1px solid #f1f3f7';
export const darkgrey = '#8d94ad';
export const blue = '#4c88f9';
export const blueMidnight = '#212c3a';
export const white = '#fff';

export const globalTheme = isMobileSite => ({
  isMobileSite,
  color: {
    blueMidnight,
    white,
    darkgrey,
    blue,
    mainTurboColor
  },
  fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  border: defaultBorder,
  maskColor: 'rgba(0, 0, 0, 0.4)'
});

export const FlexCenterAligned = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;
